<valg-table
[columnDefinition]="electoralCoalitionColumnDef"
[data]="data"
[itemName]="'electoral_coalition.item_name' | translate"
[title]="'electoral_coalition.title' | translate"
[hasPagination]="false"
[displayItemCount]="false"
[hasMainActionButton]="false">
    <h2 class="m-0 text--f20 text--500">{{ 'electoral_coalition.title' | translate }}</h2>
</valg-table>